import { Helmet } from 'react-helmet-async';
// sections
import { TourGuideCreateView } from 'src/sections/tourGuide/view';

// ----------------------------------------------------------------------

export default function TourGuideCreatePage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Create a new tour guide</title>
      </Helmet>

      <TourGuideCreateView />
    </>
  );
}
